import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../components/Layout.tsx";
import Title from "../../components/Title.tsx";
import { notification } from "../../utils/Notifications.tsx";
import FilterDirectBoss from "../../components/direct-boss/FilterDirectBoss.tsx";
import TableDirectBoss from "../../components/direct-boss/TableDirectBoss.tsx";
import PaginationDirectBoss from "../../components/direct-boss/PaginationDirectBoss.tsx";
import {
  setDirectBosses,
  setLoading,
  setTotal,
} from "../../store/slices/directBossSlice.ts";
import { fetchDirectBosses } from "../../services/direct-boss.service.ts";
import { RootState } from "../../store/index.ts";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import {
  directBossPageStyles,
  DIRECT_BOSS_PAGE_KEYFRAMES,
} from "../../components/direct-boss/directBossPageStyles.ts";

const AllDirectBoss = () => {
  const dispatch = useDispatch();
  const { page, limit, loading, query, sortBy, defaultSort, fetch, total } =
    useSelector((state: RootState) => state.directBoss);
  useAppSettings();

  const [authDenied, setAuthDenied] = React.useState(false);

  const fetchDirectBossesData = async () => {
    dispatch(setLoading(true));
    try {
      const offset = page === 0 ? 0 : page * limit;
      let queryToSend = query;
      if (queryToSend.length === 0) {
        queryToSend = "isActive=true";
      }

      const filter = `?sort=${sortBy}&order=${defaultSort}&offset=${offset}&limit=${limit}&${queryToSend}`;
      const response = await fetchDirectBosses(filter);

      const results = response.results || [];
      const totalCount = response.total || 0;

      dispatch(setDirectBosses(results));
      dispatch(setTotal(totalCount));
      setAuthDenied(false);
    } catch (error: any) {
      console.error("Error fetching direct bosses:", error);
      dispatch(setDirectBosses([]));
      dispatch(setTotal(0));
      const denied = error?.response?.status === 403;
      setAuthDenied(denied);
      notification(
        "Error",
        denied
          ? "No tienes autorización para ver los jefes directos"
          : "Error al cargar los jefes directos",
        "danger",
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchDirectBossesData();
  }, [page, limit, query, sortBy, defaultSort, fetch]);

  return (
    <Layout loading={loading}>
      <style>{DIRECT_BOSS_PAGE_KEYFRAMES}</style>
      <Title
        baseTitle="Jefes Directos"
        basePath="/direct-boss"
        activeTitle="Lista"
        title="Gestión de Jefes Directos"
      />
      <div style={directBossPageStyles.shell}>
        <div style={directBossPageStyles.panel}>
          <div
            style={{
              padding: "14px 20px",
              borderBottom: "1px solid #e2e8f0",
              background:
                "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
            }}
          >
            <div>
              <p
                style={{
                  margin: 0,
                  fontSize: 13,
                  color: "#64748b",
                  fontWeight: 500,
                }}
              >
                Colaboradores con equipo asignado
              </p>
              <p
                style={{
                  margin: "4px 0 0",
                  fontSize: 22,
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                {authDenied
                  ? "Sin autorización"
                  : `${total} ${total === 1 ? "jefe directo" : "jefes directos"}`}
              </p>
            </div>
          </div>
          <div style={directBossPageStyles.panelBody}>
            {authDenied ? (
              <p className="text-danger mb-0">
                No tienes autorización para ver los jefes directos de esta sucursal.
              </p>
            ) : (
              <>
                <FilterDirectBoss />
                <TableDirectBoss />
                <div style={{ marginTop: 16 }}>
                  <PaginationDirectBoss />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AllDirectBoss;
